import { gql } from '@apollo/client';

export const DESTROY_AD = gql`
  mutation DestroyAd(
    $adId: ID!
    $deleteReasonId: ID!
    $deleteReasonDescription: String
    $source: SourceEnum!
  ) {
    destroyAd(
      adId: $adId
      deleteReasonId: $deleteReasonId
      deleteReasonDescription: $deleteReasonDescription
      source: $source
    ) {
      entity
      errors {
        message
        path
      }
    }
  }
`;

export const CREATE_CALL = gql`
  mutation CreateCall($shopId: ID, $adId: ID, $source: SourceEnum!) {
    createCall(shopId: $shopId, adId: $adId, source: $source) {
      entity
      errors {
        message
        path
      }
    }
  }
`;

export const CREATE_REPORT = gql`
  mutation CreateReport($adId: ID!, $reportReasonId: ID!, $body: String!) {
    createReport(adId: $adId, reportReasonId: $reportReasonId, body: $body) {
      entity
      errors {
        message
        path
      }
    }
  }
`;

export const PROLONG_AD = gql`
  mutation ProlongAd($adId: ID!) {
    prolongAd(adId: $adId) {
      entity
      errors {
        message
        path
      }
    }
  }
`;

export const CREATE_AD = gql`
  mutation CreateAd($adParams: CreateAdAttributes!) {
    createAd(adParams: $adParams) {
      entity {
        id
        status
        path
      }
      errors {
        code
        message
        extensions {
          code
        }
        path
      }
    }
  }
`;

export const UPDATE_AD = gql`
  mutation UpdateAd(
    $adId: ID!
    $source: SourceEnum!
    $adParams: UpdateAdAttributes!
  ) {
    updateAd(adId: $adId, source: $source, adParams: $adParams) {
      entity {
        id
        path
      }
      errors {
        code
        message
        extensions {
          code
        }
        path
      }
    }
  }
`;

export const CREATE_AD_SUBMISSION = gql`
  mutation CreateAnalyticLog(
    $flowId: ID
    $status: AdSubmissionStatus!
    $source: SourceEnum!
    $categoryId: ID!
  ) {
    createAdSubmission(
      flowId: $flowId
      status: $status
      source: $source
      categoryId: $categoryId
    ) {
      entity
      errors {
        message
      }
    }
  }
`;

export const ARCHIVE_AD = gql`
  mutation ArchiveAd($adId: ID!) {
    archiveAd(adId: $adId) {
      entity
      errors {
        message
        path
      }
    }
  }
`;
